/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { GeneralSection } from "../../general/index";

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({ questionnaire }) {
  return questionnaire.map(question => {
    if ([1433].includes(question.idQuestion)) {
      const tax = questionnaire.find(question => question.idQuestion === 1464);

      for (const q of tax.childrenQuestions) {
        if (q.idQuestion === 1796 || q.idQuestion === 1797 || q.idQuestion === 2214) {
          q.behaviorObject.isRequired = question.idAnswerOption === 7012;
          q.visibleQuestion = question.idAnswerOption === 7012;
        }
      }
    }

    if (question.idQuestion === 1464) {
      question.disabled = true;
    }

    if (question.idQuestion === 2214 && question.idAnswerOption) {
      questionnaire.map(qst => {
        if (qst.idQuestion === 1797) {
          qst.behaviorObject.administeredByAnswer = question.idAnswerOption || null;
        }
        return qst;
      })
    }

    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
}) {
  try {
    let saveQuestionnaire = false;

    if ([1433].includes(question.idQuestion)) {
      saveQuestionnaire = true;
      const { idAnswerOption } = value;

      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if ([1796, 1797, 2214].includes(qst.idQuestion)) {
          qst.visibleQuestion = idAnswerOption === 7012;
          qst.behaviorObject.isRequired = idAnswerOption === 7012;
          qst.answer = "";
          qst.answerJson = "";
          setFieldValue && setFieldValue(qst.key, "");
        }

        return qst;
      })
    }

    if (question.idQuestion === 1796) {
      saveQuestionnaire = true;
      const { idAnswerOption } = value;

      if(idAnswerOption && idAnswerOption !== "") {
        questionnaireUpdated = questionnaireUpdated.map(qst => {
          if ([1797, 2214].includes(qst.idQuestion)) {
            qst.answer = "";
            qst.answerJson = "";
            setFieldValue && setFieldValue(qst.key, "");
          }
          
          return qst;
        })
      }
    }

    if (question.idQuestion === 2214) {
      saveQuestionnaire = true;
      const { idAnswerOption } = value;

      if(idAnswerOption && idAnswerOption !== "") {
        questionnaireUpdated = questionnaireUpdated.map(qst => {
          if (qst.idQuestion === 1797) {
            qst.behaviorObject.administeredByAnswer = value?.idAnswerOption || null;
            qst.answer = "";
            qst.answerJson = "";
            setFieldValue && setFieldValue(qst.key, "");
          }
          
          return qst;
        })
      }
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);
  } catch (e) {
    console.log('FEE_PAYABLE_BY - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("FEE_PAYABLE_BY - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('FEE_PAYABLE_BY - handleRequestSerproCnpj - error', e)
  }
};

function handleGroup({
  insurerGroup,
  feePayableByGroup,
  setFeePayableByGroup,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
}) {
  try {
    let newFeePayableByGroup = [];
    const cloneFeePayableByGroup = JSON.parse(JSON.stringify(feePayableByGroup[0]));

    for (const groupQuestions of insurerGroup) {
      const feeType = groupQuestions.find((question) => question.idQuestion === 1380);

      if (feeType.answer) {
        const groupThatAlreadyHasThisFeeType = feePayableByGroup.find((group) => group.find((question) => question.idQuestion === 1464 && question.answer === feeType.answer));

        if (groupThatAlreadyHasThisFeeType) {
          const groupAlreadyPushed = newFeePayableByGroup.find((group) => group.find((question) => question.idQuestion === 1464 && question.answer === feeType.answer));

          if (!groupAlreadyPushed) {
            newFeePayableByGroup.push(groupThatAlreadyHasThisFeeType)
          }
        } else {
          const groupAlreadyPushed = newFeePayableByGroup.find((group) => group.find((question) => question.idQuestion === 1464 && question.answer === feeType.answer));

          if (!groupAlreadyPushed) {
            let newFeePayableByGroupAux = GeneralSection.events.createSectionRow({
              questions: cloneFeePayableByGroup,
            })

            newFeePayableByGroupAux = newFeePayableByGroupAux.map(question => {
              if (question.idQuestion === 1464) {
                question.answer = feeType.answer;
                question.answerJson = feeType.answerJson;
                question.disabled = true;
              }

              if (question.idQuestion === 1796 || question.idQuestion === 1797 || question.idQuestion === 2214) {
                question.behaviorObject.isRequired = false;
                question.visibleQuestion = false;
              }

              if (question.idQuestion === 1797) {
                question.behaviorObject.administeredByAnswer = question.idAnswerOption || null;
              }

              return question;
            })

            newFeePayableByGroup.push(newFeePayableByGroupAux)
          }
        }
      }
    }

    const feePayableByGroupsToDelete = feePayableByGroup.filter((group) => !newFeePayableByGroup.includes(group));

    const feePayableByQuestionnaireAnswersToDelete = [];

    for (const group of feePayableByGroupsToDelete) {
      const allQuestion = group.map((question) => question.idQuestionnaireAnswers).filter((idQuestionnaireAnswers) => idQuestionnaireAnswers);

      feePayableByQuestionnaireAnswersToDelete.push(...allQuestion);
    }

    setQuestionnaireAnswersToDelete([...questionnaireAnswersToDelete, ...feePayableByQuestionnaireAnswersToDelete]);

    setFeePayableByGroup(newFeePayableByGroup);

    return newFeePayableByGroup
  } catch (e) {
    console.log('FEE_PAYABLE_BY - handleGroup - error', e)
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
  handleGroup,
};

export { events };